<div class="application-info">
  <div class="application-info__item application-info__item--version">
    <div>version:</div>
    <div>{{ version }}</div>
  </div>
  <div
    *ngIf="commitInfo"
    class="application-info__item application-info__item--commit_info"
  >
    <div>build:</div>
    <div>{{ commitInfo }}</div>
  </div>
</div>
